import type {
  INotification,
  TNotificationState,
} from 'libs/design-system/src/types/notification/notification';

import {
  Bell,
  Check,
  CircleExclamation,
  CircleInfo,
} from '@unified-checkout/design-system/icons/index';

export const NOTIFICATION_STATUS = {
  SUCCESS: 'success',
  ERROR: 'danger',
  WARNING: 'warning',
  PRIMARY: 'primary',
  NORMAL: 'normal',
} as const;

export const DEFAULT_ICONS = {
  [NOTIFICATION_STATUS.SUCCESS]: Check,
  [NOTIFICATION_STATUS.ERROR]: CircleExclamation,
  [NOTIFICATION_STATUS.WARNING]: CircleExclamation,
  [NOTIFICATION_STATUS.PRIMARY]: CircleInfo,
  [NOTIFICATION_STATUS.NORMAL]: Bell,
};

export const NOTIFIER_TIMEOUT = 3;

const INITIAL_OVERRIDE_PROPS = {
  timeout: NOTIFIER_TIMEOUT,
  icon: DEFAULT_ICONS[NOTIFICATION_STATUS.NORMAL],
  onCloseHandler: () => {},
};

export const INITIAL_STATES = {
  show: false,
  title: '',
  state: NOTIFICATION_STATUS.NORMAL as TNotificationState,
  overrideProps: INITIAL_OVERRIDE_PROPS,
};
